import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IMAGE_CONSTANT } from '../constants/app';
import { fetchCommunityProfileRequest } from '../store/action/community';
import { getUserAttribute, isLoggedIn } from '../utils/helpers';

// Profile photo uploads land on the community profile (`avatar_url`).
// The legacy user `profile_pic` is not updated by that upload, so every
// avatar surface has to prefer the community image.
const useProfileAvatar = () => {
  const dispatch = useDispatch();
  const communityProfile = useSelector(state => state.community?.profile);
  const user = useSelector(state => state.user?.user);

  useEffect(() => {
    if (isLoggedIn() && !communityProfile) {
      dispatch(fetchCommunityProfileRequest());
    }
  }, [dispatch, communityProfile]);

  return (
    communityProfile?.avatar_url ||
    user?.attributes?.profile_pic ||
    getUserAttribute('profile_pic') ||
    IMAGE_CONSTANT.defaultProfileIcon
  );
};

export default useProfileAvatar;
